import { FaUsers } from "react-icons/fa";
import { RxDashboard } from "react-icons/rx";
import Dashboard from "./Dashborad";
import { useState } from "react";
import CustomerTable from "./Customers";
import Navigation from "../../components/navigation/Navigation";

const Administrator = () => {
  const email = localStorage.getItem("emailForVerification");
  // if (email !== "support@scriptwrite.ai") { window.location.href = "/login" }

  const [isDashboard, setIsDashboard] = useState(true);
  const [isCustomers, setIsCustomers] = useState(false);

  return (
    <div className="">
      <Navigation />
      <div className="w-full grid grid-cols-[15%_85%]">
        <div className="min-h-[94vh] p-3">
          <button
            className={`flex w-full items-center justify-start rounded-xl px-3 py-2 gap-3 hover:bg-neutral-200 `}
            onClick={() => {
              setIsDashboard(true);
              setIsCustomers(false);
            }}
          >
            <RxDashboard size={"24px"} />
            <p className="font-medium">Dashboard</p>
          </button>
          <button
            className={`flex w-full items-center justify-start rounded-xl px-3 py-2 gap-3 hover:bg-neutral-200 `}
            onClick={() => {
              setIsDashboard(false);
              setIsCustomers(true);
            }}
          >
            <FaUsers size={"24px"} />
            <p className="font-medium">Customers</p>
          </button>
        </div>
        {isDashboard && <Dashboard />}
        {isCustomers && <CustomerTable />}
      </div>
    </div>
  );
};

export default Administrator;
